export const ATELIER_SECTION_TYPES = Object.freeze({
  HERO: 'atelier-hero',
  CATEGORIES: 'atelier-category-mosaic',
  SERVICES: 'atelier-services',
  PRODUCTS: 'atelier-bestsellers',
  STORY: 'atelier-story',
});

export const ATELIER_SECTION_META = Object.freeze([
  { type: ATELIER_SECTION_TYPES.HERO, name: 'Atelier welcome', icon: 'layout', description: 'A calm introduction with image, copy and action' },
  { type: ATELIER_SECTION_TYPES.CATEGORIES, name: 'Rituals mosaic', icon: 'grid', description: 'A product-category discovery mosaic' },
  { type: ATELIER_SECTION_TYPES.SERVICES, name: 'Services feature', icon: 'calendar', description: 'An optional booking or service callout' },
  { type: ATELIER_SECTION_TYPES.PRODUCTS, name: 'Bestsellers', icon: 'grid', description: 'A selected rail from your catalogue' },
  { type: ATELIER_SECTION_TYPES.STORY, name: 'Ingredient story', icon: 'quote', description: 'A closing brand or ingredient story' },
]);

export function createAtelierSections() {
  return [
    { id: 'atelier-hero-1', type: ATELIER_SECTION_TYPES.HERO, content: { eyebrow: 'A moment for you', title: '', body: '', buttonText: 'Explore the collection', buttonLink: '/shop', image: '', mobileImage: '' }, settings: { minHeight: '680px', contentPosition: 'left', imagePosition: 'center' } },
    { id: 'atelier-categories-1', type: ATELIER_SECTION_TYPES.CATEGORIES, content: { eyebrow: 'Shop by ritual', title: 'Care, considered.' }, settings: { maxCategories: 4 } },
    { id: 'atelier-services-1', type: ATELIER_SECTION_TYPES.SERVICES, content: { eyebrow: 'In studio', title: 'Make time for your ritual.', body: 'Book a service, consultation or private appointment with us.', buttonText: 'Explore services', buttonLink: '/shop' }, settings: { enabled: true } },
    { id: 'atelier-products-1', type: ATELIER_SECTION_TYPES.PRODUCTS, content: { eyebrow: 'Most loved', title: 'Everyday essentials.', linkText: 'Shop all', link: '/shop' }, settings: { count: 4 } },
    { id: 'atelier-story-1', type: ATELIER_SECTION_TYPES.STORY, content: { eyebrow: 'Our philosophy', title: 'Care begins with a little more intention.', body: 'Thoughtfully chosen pieces for the rhythms that make you feel like yourself.', linkText: 'Our story', link: '/about', image: '' }, settings: {} },
  ];
}

export function isAtelierSection(section) {
  return ATELIER_SECTION_META.some((item) => item.type === section?.type);
}
